export async function fetchAllPaginated(apiFn, params = {}, batchSize = 500, maxBatches = 50) {
  let all = [];
  let skip = 0;
  let batches = 0;

  while (batches < maxBatches) {
    const resp = await apiFn({ ...params, limit: batchSize, skip });
    const data = resp.data || [];

    all = all.concat(data);

    if (data.length < batchSize) break;

    skip += batchSize;
    batches += 1;
  }

  return all;
}
